/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 * EN:英文
 */
 export default {
  userName: { SC:"用户编号", TC: "用戶編號", EN: "User ID"},
  login: { SC:"登录", TC: "登錄", EN: "Sign In"},
  forgotPpassword: { SC: "忘记密码", TC: "忘記密碼", EN: "Forgot Password"},
  forgotPasswordInfo: {
    SC: "Staff and students of THEi: 您的请求将直接发送至VTC CNA服务进行处理。",
    TC: "Staff and students of THEi: 您的請求將直接發送至VTC CNA服務進行處理。",
    EN: "Staff and students of THEi: Please access VTC CNA Service for processing."
  },
  forgotPasswordPartner: {
    SC: "Industry Partners: 请提供您的帐户ID，系统将自动向您帐户中的注册电子邮件地址发送新密码。",
    TC: "Industry Partners: 請提供您的帳戶ID，系統將自動向您賬戶中的註冊電子郵件地址發送新密碼。",
    EN: "Industry Partners: Please provide your account ID, and the system will automatically send a new password to the registered email address in your account."
  },
  submit: { SC: "提交", TC: "提交", EN: "Submit"},
  back: { SC: "返回", TC: "返回", EN: "Back"},
  resetPassword: { SC: "重置密码", TC: "重置密碼", EN: "Reset Password"},
  send: { SC: "发送成功", TC: "發送成功", EN: "Sent successfully."},
  userNameIsNoNull: { SC:"用戶编号不能为空", TC: "用戶編號不能為空", EN: "User Code is required." },
}